﻿const locks = document.querySelectorAll('[data-lock]');

document.addEventListener('DOMContentLoaded', function (event) {
  locks.forEach((lock, index, parent) => {
	let options = JSON.parse(lock.dataset.lock);
	let target = document.querySelector(options.targetSelector);
	lock.addEventListener('click', function (e) {
	  switch (target.tagName) {
		case 'SELECT':
		  target.classList.toggle('readonly');
		  target.parentNode.querySelector('.ss-main').classList.toggle('readonly');
		  break;
		default:
		  break;
	  }

	  if (target.attributes.readonly) {
		target.removeAttribute('readonly');
	  } else {
		target.setAttribute('readonly', '');
	  }

	  for (let child of e.currentTarget.children) {
		child.classList.toggle('hidden');
	  }
	});
  });
});
